import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import {
  AddOpportunityTypeMutation,
} from "../../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { getOpportunitytype } from "../../../lib/graphQL/graphQuery";
import {
  deleteOpportunitytypeService,
  updateOpportunityService,
} from "../../../lib/appUtliz/OpportunitTypeService";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";

export default function AddOpportunityType() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const params = useLocation();

  const id = params.search.slice(1);
  const [selectedData, setSelectedData] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [pendingLoading, setPendingLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus , errormessage, setErrormessage} = useError();

  const [opportunityTypeData, setOpportunityTypeData] = useState({
    // OpportunityType Details
    typeName: "",
    description: "",
    // OpportunityType Status
    typeNameStatus: "unchecked",
    descriptionStatus: "unchecked",
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });


  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getOpportunitytype, {
        id: id,
      });
      const v = res.getOpportunitytype;
      setSelectedData(v);
      setOpportunityTypeData({
        typeName: v.typeName,
        description: v.description,

        typeNameStatus: "success",
        descriptionStatus: "success",
      });
    } catch (err) {}
  };

  //Create Mutation
  const handleAddOpportunityTypeData = async () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: async () => {
          setCirleLoading(true);
          try {
            const response = await request(BASEURL, AddOpportunityTypeMutation, {
              user: currentUser?.id,
              typeName: opportunityTypeData.typeName,
              description: opportunityTypeData.description,
            });
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            setSuccessStatus(true);
            setSucessTitle("OpportunityType Created");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/opportunityType");
            }, 1000);
          } catch (error) {
            console.error(error?.response.errors[0].message, "jj");
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            setErrorStatus(true);
            setErrormessage(error?.response?.errors[0]?.message);
            setTimeout(() => {
              setErrorStatus(false);
            }, 1000);
          } finally {
            setCirleLoading(false);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
  
  //Update Mutation
  const handleEditOpportunityTypeData = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Edit your details.",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          const values = {
            typeName: opportunityTypeData.typeName,
            description: opportunityTypeData.description,
          };
  
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          const {updateStatus,errormessage} = await updateOpportunityService(id, values);
          setCirleLoading(false);
          if (updateStatus) {
            setSuccessStatus(true);
            setSucessTitle("OpportunityType Updated");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/opportunityType");
            }, 1000);
          } else {
            setErrorStatus(true);
            setErrormessage(errormessage)
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
  
    //Delete Mutation
    const handleDelteOpportunitytype = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your detail.",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setPendingLoading(true);
          const delteStatus = await deleteOpportunitytypeService(id);
          if (delteStatus) {
            setSuccessStatus(true);
            setSucessTitle("OpportunityType Deleted");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/opportunityType");
            }, 1000);
          } else {
            setErrorStatus(true);
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setOpportunityTypeData({
      typeName: selectedData?.typeName,
      description: selectedData?.description,

      typeNameStatus: "success",
      descriptionStatus: "success",
    });
  };

    //Cancel Function
    const handleCancelOpportunitytypeData = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message:
          "The Entered Details will not be saved. Do you want to Cancel it?",
        showCancel: true,
        showConfirm: true,
        onConfirm: async () => {
          navigate("/opportunityType");
   
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      opportunityTypeData.typeNameStatus === "success" &&
      (opportunityTypeData.descriptionStatus === "success" ||
        opportunityTypeData.descriptionStatus === "unchecked")
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Handle Change
  const handleOpportunityTypeDataChange = (event) => {
    let opportunityTypeState = { ...opportunityTypeData };
    const changeAllowed = true;
    switch (event.target.name) {
      case "typeName":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            opportunityTypeState[event.target.name + "Status"] = "success";
          } else {
            opportunityTypeState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
      case "description":
        {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,50})$");
          if (alphaNLenghthRegex.test(event.target.value?.trim())) {
            opportunityTypeState[event.target.name + "Status"] = "success";
          } else {
            opportunityTypeState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
        }
        break;
    }
    if (changeAllowed) {
      opportunityTypeState[event.target.name] = event.target.value;
    }
    setOpportunityTypeData(opportunityTypeState);
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      OpportunityType Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDelteOpportunitytype}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Opportunity Type Details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Opportunity Type Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "50vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                                    <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                                    <MaterialTypography
                                                    sx={{color:'#460058',fontFamily:'Aptos'}}
                                                      component="label"
                                                      variant="body2"
                                                      fontWeight="700"
                                                    >
                                                      Opportunity Type Information
                                                    </MaterialTypography>
                                                  </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Type Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="typeName"
                  placeholder="Enter Type Name"
                  size="small"
                  value={opportunityTypeData.typeName}
                  onChange={handleOpportunityTypeDataChange}
                  error={
                    opportunityTypeData.typeNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityTypeData.typeNameStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityTypeData.typeNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Type Name should be maximum 20 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  size="small"
                  placeholder="Write description ..."
                  value={opportunityTypeData.description}
                  onChange={handleOpportunityTypeDataChange}
                  error={
                    opportunityTypeData.descriptionStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    opportunityTypeData.descriptionStatus === "success"
                      ? true
                      : false
                  }
                  multiple
                  rows={3}
                  disabled={togglePage?.view === true ? true : false}
                />
                {opportunityTypeData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description should be maximum 50 characters long
                    </FormHelperText>
                  </FormControl>
                )}
                
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            paddingTop="20px"
          >
            {/* <MaterialButton
              //   sx={{ m: 2 }}
              variant="gradient"
              color="dark"
            >
              <Link to={"/opportunityType"}>
                <span style={{ color: "white" }}>Cancel</span>
              </Link>
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddOpportunityTypeData}
            >
              Submit
            </MaterialButton> */}
            <MaterialBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={3}
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    onClick={handleDiscardButton}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 1 }}
                    variant="gradient"
                    size="small"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleEditOpportunityTypeData}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 1 }}
                    variant="gradient"
                    size="small"
                    color="dark"
                    onClick={handleCancelOpportunitytypeData}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 1 }}
                    variant="gradient"
                    size="small"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleAddOpportunityTypeData}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
